import { FC, ReactElement, useMemo } from 'react';

import { useTypedSelector } from '../../../redux/store';

interface ConnectedSearchPageWrapperChildProps {
    showNullState: boolean;
}

interface ConnectedSearchPageWrapperProps {
    children: (childProps: ConnectedSearchPageWrapperChildProps) => ReactElement;
}

export const ConnectedSearchPageWrapper: FC<ConnectedSearchPageWrapperProps> = ({
    children,
}): ReactElement => {
    const hasFetchedVariants = useTypedSelector(state => state.meilisearchSlice.hasFetchedVariants);
    const hasFetchedPages = useTypedSelector(state => state.meilisearchSlice.hasFetchedPages);
    const pageResponses = useTypedSelector(state => state.meilisearchSlice.pageResponses);
    const variantResponses = useTypedSelector(state => state.meilisearchSlice.variantResponses);

    const showNullState = useMemo((): boolean => {
        if (!hasFetchedVariants && !hasFetchedPages) {
            return false;
        }

        const hasNoVariantResults = variantResponses.search?.results
            ? variantResponses.search.results.length === 0
            : true;

        const hasNoPageResults = pageResponses.search?.results
            ? pageResponses.search.results.length === 0
            : true;

        return hasNoVariantResults && hasNoPageResults;
    }, [pageResponses, variantResponses]);

    return (
        <div>
            {children({ showNullState })}
        </div>
    );
};
